<template>
  <div>
    <vs-select
      v-if="mode === 'view'"
      ref="select"
      @onChange="onValueChanged"
      :selectedVal="selectedVal"
      :header="{label: label, multiple: isMultiple,listParams:listParams}"
      :mode="mode"
      :data="options"
      :options="listParams"
      :is-header="true"
    ></vs-select>
    <div v-if="mode === 'edit'">
      <div class="badge badge-danger" id="base-product" style="cursor: pointer" @click="_setNavItems(productsUrl)">برای ویرایش به صفحه محصولات بروید</div>
    </div>
  </div>

</template>

<script>
  import EventBus from "../_framework/bus.js";
  import * as $ from "jquery";
  import VsSelect from "../_framework/VsSelect";
  import Vue from "vue";
  export default {
    name: "client-select",
    props: {
      data: null,
      header: null,
      headerKey: null,
      mode: null,
      placeholder: null,
      type: null,
      row: null
    },
    data() {
      return {
        productsUrl : "/products",
        show: true,
        model: null,
        label: "",
        isMultiple: false,
        listParams: {},
        options: [],
        selectedVal: {}
      };
    },
    components: {
      VsSelect
    },
    methods: {
      _setNavItems(type) {
        setTimeout(() => {
          this.$router.push({path: this.productsUrl});
          EventBus.$emit("changeNavItems", type);
          $("#base-product").click();
        }, 50);
      },
      onValueChanged(val) {
        this.$emit("dataChanged", this.headerKey, val);
        EventBus.$emit("clientSelectChanged", val);
      },
      onKeyDown(event) {
        this.onValueChanged(event.target.value);
        EventBus.$emit("debtorChange", event);
        if (this.type === "number" && event.key === "e") {
          event.preventDefault();
          return;
        }
        this.$nextTick(() => {
          if (event.target.value === this.lastValue) {
            return;
          }
          this.lastValue = event.target.value;
        });
      },
      mountVSelect() {
        this.label = this.header.label;
        this.isMultiple = this.header.multiple;
        this.options = this.header.data;
        if (this.mode !== "create") {
          if (this.data && this.data.map === undefined) {
            Vue.set(
              this.selectedVal,
              this.label,
              this.data[this.label] || this.data
            );
          } else {
            this.selectedVal = this.data[this.label] || this.data;
          }
        }
        if (
          this.mode === "view" &&
          this.header &&
          this.header.data &&
          this.header.data[0] &&
          this.header.data[0].persianName
        ) {
          if (typeof this.data === "string") {
            this.header.data.map(d => {
              if (d.persianName === this.data) {
                this.selectedVal = d;
                this.onValueChanged(d);
              }
            });
          }
        }
        if (this.header.listParams) {
          this.listParams = this.header.listParams;
        } else {
          this.listParams = null;
        }
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      }
    },
    mounted() {
      this.mountVSelect();
    },
    computed: {},
    watch: {
      mode(val) {
        if (val === "edit" || val === "view") {
          this.mountVSelect();
        }
      }
    }
  };
</script>

<style scoped>
  #debtor::placeholder {
    text-align: center;
  }
</style>
